import React from "react"

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ScenarioFormComponent from './scenario-form-component';
import * as actions from '../../../actions';
import ScenarioService from '../../../service/sfp/scenario-service';

class ScenarioFormContainer extends React.Component {

	state = {
		loading: undefined,
		submitting: false
	}

	componentDidMount() {
		this.setState({
			description: this.props.scenario ? this.props.scenario.description : "",
			comments: this.props.scenario ? this.props.scenario.comments : ""
		})
	}

	render() {
		return (
			<ScenarioFormComponent
				scenario={this.props.scenario}
				description={this.state.description}
				comments={this.state.comments}
				onDescriptionChange={(e) => { this.setState({description: e.target.value}) }}
				onCommentsChange={(e) => { this.setState({comments: e.target.value}) }}
				onSubmit      			= {this._handleSubmit}
				submitting    			= {this.state.submitting}
				delete							= {this.props.delete}
				duplicate						= {this.props.duplicate}
				validate						= {this.props.validate}
			/>
		)
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true })

		if (this.props.delete) {
			ScenarioService.deleteScenario(this.props.scenario.id)
				.then(this._resolveDeleteScenario.bind(this, event), this._rejectDeleteScenario)
		} else if (this.props.duplicate) {
			ScenarioService.duplicateScenario(this.props.scenario.id)
				.then(this._resolveCreateScenario.bind(this, event), this._rejectCreateScenario)
		} else {
			var scenario = {}

			if (this.props.validate) {
				scenario = {
					validated: !this.props.scenario.validated
				}
			} else {
				scenario = {
					year: this.props.year,
					description: event.target.description.value,
					comments: event.target.comments.value,
					localAuthority: this.props.currentLocalAuthority.id
				}
			}

			if (this.props.scenario) {
				ScenarioService.updateScenario(this.props.scenario.id, scenario)
					.then(this._resolveUpdateScenario.bind(this, event), this._rejectUpdateScenario)
			} else {
				ScenarioService.createScenario(scenario)
					.then(this._resolveCreateScenario.bind(this, event), this._rejectCreateScenario)
			}
		}
	}

	_rejectCreateScenario = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveCreateScenario = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onCreated(response)
		})
	}

	_rejectUpdateScenario = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveUpdateScenario = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onUpdated(response)
		})
	}

	_rejectDeleteScenario = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveDeleteScenario = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onDeleted(response)
		})
	}

}

const mapStateToProps = (state) => ({
	currentLocalAuthority: state.currentLocalAuthority
})

const mapDispatchToProps = dispatch => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioFormContainer);



// WEBPACK FOOTER //
// ./src/component/scenarii/common/scenario-form-container.js